import React from 'react';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from "@mui/material/Tooltip"




const PREFIX = 'MoreInfoSwitch';

const classes = {
  root: `${PREFIX}-root`,
  switchBase: `${PREFIX}-switchBase`,
  thumb: `${PREFIX}-thumb`,
  track: `${PREFIX}-track`,
  checked: `${PREFIX}-checked`
};

const StyledTooltip = styled(Tooltip)((
  {
    theme
  }
) => ({
  // switch: {
  //     margin:" 0px 8px",
  //     boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  //   },

  //   switchBase: {
  //     padding:"3px !important",
  //     '&$unChecked': {
  //         color: "#80deea",

  //       },

  //     '&$checked': {
  //       color: "#80deea",
  //     },
  //     '&$checked + $track': {
  //       backgroundColor: "#00bcd4",
  //     },
  //   },
  [`& .${classes.root}`]: {
      width: 44,
      height: 20,
      padding: 0,
      display: 'flex',
    },

  [`& .${classes.switchBase}`]: {
    padding: 1,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(24px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },

  [`& .${classes.thumb}`]: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },

  [`& .${classes.track}`]: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },

  [`& .${classes.checked}`]: {}
}));




const StyledSwitch = Switch;

export default function MoreInfoSwitch(props) {
  const [checked, setChecked] = React.useState(false);


  const toggleChecked = () => {
    props.toggle(!checked)
        setChecked((prev) => !prev);
  };

  return (
    <StyledTooltip placement="right-start" title="More info" >
      <FormGroup>
        <FormControlLabel   style={{margin:"0px 8px"}}
          control={<StyledSwitch
            color="primary"
            checkedIcon={<InfoIcon  style={{ fontSize: 18, margin:0, padding: 0, }} />}
            icon={<InfoIcon style={{ fontSize: 18, margin:0, padding: 0, }}/>}
            checked={checked}
            onChange={toggleChecked}
            classes={{
              root: classes.root,
              switchBase: classes.switchBase,
              thumb: classes.thumb,
              track: classes.track,
              checked: classes.checked
            }} />}
        />
      </FormGroup>
    </StyledTooltip>
  );
}